module.exports = __webpack_public_path__ + "assets/87f2bce4e73e4a4e03374dbfdf363859.png";